import { AxiosResponse } from 'axios';
import { IGoalAndTargetRow } from '../../../../Modules/Common/WorkforceProfile/GoalsAndTargetsCommon';
import { WorkforceProfileGoalsAndTargets } from '../../../Model/Dto/EmploymentEquity/WorkforceProfileGoalsAndTargets/WorkforceProfileGoalsAndTargets';
import { axiosCoreInstance } from '../../AxiosCoreInterceptor';
import { EEOccupationalLevel } from '../../../../Component/Model/Enum/EmploymentEquity';
import * as ApiUrls from './ApiUrl.WorkforceProfileGoalsAndTargets';
import { WorkforceProfileOccupationalLevelTargets } from '../../../Model/Dto/EmploymentEquity/WorkforceProfileGoalsAndTargets/WorkforceProfileOccupationalLevelTargets';
import { IndividualMovements } from '../../../Model/Dto/EmploymentEquity/WorkforceProfile_EEA2/IndividualMovements';
import dayjs from 'dayjs';

export const WorkforceProfileGoalsAndTargetsService = {
	GetWorkforceProfileGoalsAndTargetsData: (
		scorecardId: string,
		isDisabled?: boolean,
		date?: Date | null
	): Promise<AxiosResponse<WorkforceProfileGoalsAndTargets.DtoOut>> => {
		const params = {
			scorecardId: scorecardId,
			isDisabled: isDisabled,
			date: dayjs(date).format('YYYY-MM-DDTHH:mm:ss')
		};
		return axiosCoreInstance.get(`${ApiUrls.GetWorkforceProfileGoalsAndTargets}`, { params: params });
	},
	SaveWorkforceProfileRow: (row: IGoalAndTargetRow): Promise<AxiosResponse<WorkforceProfileGoalsAndTargets.rowUpdateDtoOut>> =>
		axiosCoreInstance.post(ApiUrls.SaveRow, row),
	GetComments: (
		scorecardId: string,
		isDisabled?: boolean
	): Promise<AxiosResponse<WorkforceProfileGoalsAndTargets.CommentsDtoOut[]>> => {
		const params = {
			scorecardId: scorecardId,
			isDisabled: isDisabled
		};
		return axiosCoreInstance.get(`${ApiUrls.GetComments}`, { params: params });
	},
	SaveComment: (comment: WorkforceProfileGoalsAndTargets.CommentDtoIn): Promise<AxiosResponse<number>> =>
		axiosCoreInstance.post(ApiUrls.SaveComment, comment),

	GetOccupationalLevelTables: (
		scorecardId: string,
		occupationalLevelType: EEOccupationalLevel,
		isDisabled: boolean,
		date?: Date
	): Promise<AxiosResponse<WorkforceProfileOccupationalLevelTargets.OccupationalLevelSection>> => {
		const params = {
			scorecardId: scorecardId,
			occupationalLevelType: occupationalLevelType,
			isDisabled: isDisabled,
			date: date == undefined ? date : dayjs(date).format('YYYY-MM-DDTHH:mm:ss')
		};
		return axiosCoreInstance.get(`${ApiUrls.GetOccupationalLevelTables}`, { params: params });
	},

	GetOccupationalLevelDrilldown: (
		drilldownRequestRequest: WorkforceProfileOccupationalLevelTargets.OccupationalLevelDrilldownRequest
	): Promise<AxiosResponse<IndividualMovements.Response>> => {
		return axiosCoreInstance.post(`${ApiUrls.GetOccupationalLevelDrilldown}`, drilldownRequestRequest);
	},
	GetDisabledSummary: (
		scorecardId: string,
		date?: Date
	): Promise<AxiosResponse<WorkforceProfileOccupationalLevelTargets.OccupationalLevelSection>> => {
		const params = {
			scorecardId: scorecardId,
			date: dayjs(date).format('YYYY-MM-DDTHH:mm:ss')
		};
		return axiosCoreInstance.get(`${ApiUrls.GetDisabledSummary}`, { params: params });
	},
	GetAppliedSectoralTargets: (
		scorecardId: string
	): Promise<AxiosResponse<WorkforceProfileOccupationalLevelTargets.AppliedSectoralTargets[]>> => {
		const params = {
			scorecardId: scorecardId
		};
		return axiosCoreInstance.get(`${ApiUrls.GetAppliedSectoralTargets}`, { params: params });
	},
	GetAllProvincesEAPTargets: (
		scorecardId: string
	): Promise<AxiosResponse<WorkforceProfileOccupationalLevelTargets.AllProvincesEAPTargets[]>> => {
		const params = {
			scorecardId: scorecardId
		};
		return axiosCoreInstance.get(`${ApiUrls.GetAllProvincesEAPTargets}`, { params: params });
	},
	GetApplicableEAPYear: (
		scorecardId: string
	): Promise<AxiosResponse<string>> => {
		const params = {
			scorecardId: scorecardId
		};
		return axiosCoreInstance.get(`${ApiUrls.GetApplicableEAPYear}`, { params: params });
	}
};
